module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_01.c691942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_01.png
// module id = 07ER
// module chunks = 10